import { render, staticRenderFns } from "./planBuy.vue?vue&type=template&id=14b22677&scoped=true"
import script from "./planBuy.vue?vue&type=script&lang=js"
export * from "./planBuy.vue?vue&type=script&lang=js"
import style0 from "./planBuy.vue?vue&type=style&index=0&id=14b22677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b22677",
  null
  
)

export default component.exports